var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTempIconOrbitSnap = function SvgTempIconOrbitSnap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12V4l6 3.5v8l-6-3.5Z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6.75a.75.75 0 0 1 .75.75v4.065l3.122 1.784a.75.75 0 0 1-.744 1.302L7.5 12.864 4.372 14.65a.75.75 0 0 1-.744-1.302l3.122-1.784V7.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.625 3.64a1.75 1.75 0 0 1 1.75 0l5.495 3.172c.542.312.875.89.875 1.515v6.346a1.75 1.75 0 0 1-.875 1.515l-5.495 3.173a1.75 1.75 0 0 1-1.75 0L1.13 16.188a1.75 1.75 0 0 1-.875-1.515V8.327c0-.625.333-1.203.875-1.515l5.495-3.173Zm1 1.298a.25.25 0 0 0-.25 0L1.88 8.111a.25.25 0 0 0-.125.216v6.346c0 .089.047.171.125.216l5.495 3.173a.25.25 0 0 0 .25 0l5.495-3.173a.25.25 0 0 0 .125-.216V8.327a.25.25 0 0 0-.125-.216L7.625 4.938Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.293 7.983a.75.75 0 0 1 .745-.755l2-.012a.75.75 0 0 1 .01 1.5l-2 .012a.75.75 0 0 1-.755-.745ZM11.017 3.76l-.012-2a.75.75 0 0 1 1.5-.01l.012 2a.75.75 0 0 1-1.5.01ZM14.103 4.91a.748.748 0 0 1 .216-.53l2.328-2.356a.75.75 0 1 1 1.067 1.054l-2.327 2.355a.75.75 0 0 1-1.284-.522Z"
  })));
};
export default SvgTempIconOrbitSnap;